<div
  class="w-full overflow-x-auto rounded-md border border-gray-300 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
  role="region"
  tabindex="0"
  [attr.aria-label]="caption"
>
  <table class="min-w-full border-collapse text-left text-sm">
    <caption class="sr-only">
      {{
        caption
      }}
    </caption>
    <thead>
      <tr class="bg-gray-100 text-[rgb(42,75,152)]">
        <th
          class="border-r border-b border-gray-300 px-3 py-2 font-semibold"
          scope="col"
        >
          Escalation level
        </th>
        <th
          class="border-r border-b border-gray-300 px-3 py-2 font-semibold"
          scope="col"
        >
          Contact
        </th>
        <th
          class="border-r border-b border-gray-300 px-3 py-2 font-semibold"
          scope="col"
        >
          Phone
        </th>
        <th
          class="border-b border-gray-300 px-3 py-2 font-semibold"
          scope="col"
        >
          Email
        </th>
      </tr>
    </thead>

    @for (
      row of severityLevelContacts;
      let index = $index;
      track row.severity
    ) {
      <tbody>
        @for (
          contact of row.contacts;
          let contactIndex = $index;
          track contact.name
        ) {
          <tr
            class="text-[rgb(42,75,152)]"
            [class.bg-[rgba(42,75,152,0.025)]]="index % 2"
            [class.bg-white]="!(index % 2)"
          >
            @if (contactIndex === 0) {
              <th
                class="border-r border-b border-gray-300 px-3 py-2 align-top font-medium"
                scope="rowgroup"
                [attr.rowspan]="severityLevelContactRowSpan(row)"
              >
                @if (row.link) {
                  <a
                    class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                    [fragment]="row.link"
                    [routerLink]="[]"
                    [attr.aria-label]="'View definition for ' + row.severity"
                  >
                    {{ row.severity }}
                  </a>
                } @else {
                  <span>{{ row.severity }}</span>
                }
              </th>
            }

            <th
              class="border-r border-b border-gray-300 px-3 py-2 align-top font-medium"
              scope="row"
            >
              <span>{{ contact.name }}</span>
              @if (contact.title) {
                <span class="text-gray-600"> ({{ contact.title }}) </span>
              }
            </th>

            <td class="border-r border-b border-gray-300 px-3 py-2 align-top">
              @if (contact.phones.length) {
                <ul
                  class="space-y-2"
                  [attr.aria-label]="'Phone numbers for ' + contact.name"
                >
                  @for (phone of contact.phones; track phone.number) {
                    <li class="flex items-center gap-2">
                      <mat-icon class="scale-75 opacity-75" aria-hidden="true">
                        {{ phoneTypeIcon(phone.type) }}
                      </mat-icon>
                      <span class="text-xs font-semibold text-gray-600">
                        {{ phoneTypeLabel(phone.type) }}:
                      </span>
                      <a
                        class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                        [href]="phoneHref(phone.number)"
                        [attr.aria-label]="
                          phoneTypeLabel(phone.type) +
                          ' for ' +
                          contact.name +
                          ', ' +
                          phone.number
                        "
                      >
                        {{ phone.number }}
                      </a>
                    </li>
                  }
                </ul>
              } @else {
                <span aria-label="No phone number available"
                  >Not available</span
                >
              }
            </td>

            @if (contactIndex === 0 && hasGeneralEmail(row)) {
              <td
                class="border-b border-gray-300 px-3 py-2 align-top"
                [attr.rowspan]="severityLevelContactRowSpan(row)"
              >
                <a
                  class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                  [href]="'mailto:' + row.generalEmail"
                  [attr.aria-label]="
                    'Email ' + row.severity + ' contacts at ' + row.generalEmail
                  "
                >
                  {{ row.generalEmail }}
                </a>
              </td>
            } @else if (!hasGeneralEmail(row)) {
              <td class="border-b border-gray-300 px-3 py-2 align-top">
                @if (contactEmail(contact); as email) {
                  <a
                    class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                    [href]="'mailto:' + email"
                    [attr.aria-label]="'Email ' + contact.name + ' at ' + email"
                  >
                    {{ email }}
                  </a>
                } @else {
                  <span aria-label="No email available">Not available</span>
                }
              </td>
            }
          </tr>
        } @empty {
          <tr>
            <td class="border-b border-gray-300 px-3 py-2" colspan="4">
              No contacts available
            </td>
          </tr>
        }
      </tbody>
    }
  </table>
</div>
